// extracted by mini-css-extract-plugin
export default {"root":"UNtAQl","textAvatar":"DKMRRg","anonymousAvatar":"vMdr9i"};